import React from "react";
import { Stack, FormLabel, Box } from "@mui/material";
import {
  ButtonVariantOption,
  Button,
  ButtonColorOption,
} from "@/components/Button";
import { SizingWrapperStyle } from "@/components/Wrapper";
import { CTextField } from "@/components/TextField/CTextField";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  MailTemplateFormSchema,
  type MailTemplateFormData,
} from "../../types/schemas";

interface MailTemplateFormProps {
  initialValues?: MailTemplateFormData;
  onSubmit: (data: MailTemplateFormData) => void;
  onDelete?: () => void;
  submitLabel?: string;
}

export const MailTemplateForm: React.FC<MailTemplateFormProps> = ({
  initialValues = { name: "", body: "" },
  onSubmit,
  onDelete,
  submitLabel = "保存",
}) => {
  const form = useForm<MailTemplateFormData>({
    mode: "all",
    defaultValues: initialValues,
    resolver: zodResolver(MailTemplateFormSchema),
  });

  const handleSubmit = (): void => {
    void form.handleSubmit(onSubmit)();
  };

  return (
    <>
      <Stack my={2} direction="column" spacing={1}>
        <FormLabel htmlFor="template-name">テンプレート名</FormLabel>
        <CTextField
          control={form.control}
          name="name"
          id="template-name"
          size={SizingWrapperStyle.INHERIT}
        />
        <FormLabel htmlFor="template-body">メールテンプレート</FormLabel>
        <CTextField
          control={form.control}
          name="body"
          id="template-body"
          size={SizingWrapperStyle.INHERIT}
          inputProps={{
            multiline: true,
            rows: 10,
          }}
        />
      </Stack>
      <Box
        sx={{
          mr: 2,
          my: 3,
          display: "flex",
          justifyContent: "center",
          gap: "20px",
        }}
      >
        {onDelete && (
          <Button
            label="削除"
            onClick={onDelete}
            color={ButtonColorOption.Error}
            variant={ButtonVariantOption.Outlined}
            size={SizingWrapperStyle.SMALL}
          />
        )}
        <Button
          label={submitLabel}
          disabled={!form.formState.isValid}
          onClick={handleSubmit}
          variant={ButtonVariantOption.Contained}
          size={SizingWrapperStyle.SMALL}
        />
      </Box>
    </>
  );
};
